import { PlanningConditions } from 'src/entities/PlanningHistory.entity';
import { RelaxedRuleVo } from 'src/vo/RelaxedRule.vo';

import { PlanningDialogSettings } from './dispatchModel';

export type BuildPlanningConditionsSnapshotParams = PlanningDialogSettings & {
  selectedRelaxedRules: RelaxedRuleVo[];
};

/**
 * PlanningPresenter の「送る値」から、localStorage 保存用とシナリオ履歴 (onPlanningConditionsChange) 用の
 * 両方に渡す snapshot を組み立てる。呼び出し元ごとに object を手組みすると食い違うため、正本をこの関数に絞る。
 *
 * Why not PlanningConditions の全フィールドを埋めない: isForcePlanning 等は V2Plans 専用の state で、
 *   V3Plans/Map の PlanningPresenter は持たない。
 * Why not planningPriority / dispatchScenario を書かない: #366 で優先設定を削除し、配車シナリオは
 *   モデル(SHIKI / SAHAI)に昇格した。旧履歴の表示のため型には残している。
 */
export function buildPlanningConditionsSnapshot(params: BuildPlanningConditionsSnapshotParams): PlanningConditions {
  const { autoSplitOrders, ...rest } = params;

  return {
    howToPlanning: rest.howToPlanning,
    availabilityOfExpressway: rest.availabilityOfExpressway,
    includeFutureDeliveries: rest.includeFutureDeliveries,
    splitOrders: autoSplitOrders,
    dontExchangePreroute: rest.dontExchangePreroute,
    concurrentAllOrNothing: rest.concurrentAllOrNothing,
    activateIncrementalMaxNumPistons: rest.activateIncrementalMaxNumPistons,
    selectedRelaxedRules: rest.selectedRelaxedRules,
    expandWorkingTimeStartMinutes: rest.expandWorkingTimeStartMinutes,
    expandWorkingTimeEndMinutes: rest.expandWorkingTimeEndMinutes,
    expandLoadStartMinutes: rest.expandLoadStartMinutes,
    expandLoadEndMinutes: rest.expandLoadEndMinutes,
    expandUnloadStartMinutes: rest.expandUnloadStartMinutes,
    expandUnloadEndMinutes: rest.expandUnloadEndMinutes,
    expandMaxVolumeRate: rest.expandMaxVolumeRate,
    expandMaxLoadCapacityRate: rest.expandMaxLoadCapacityRate,
    vehicleSizePreference: rest.vehicleSizePreference,
    dispatchModel: rest.dispatchModel,
  };
}
